import React, {useState} from 'react'
import {Lang} from 'yougile-lang'
import {DataObjectId} from 'yougile-model'
import {PlatformEvents} from '@api/model/platform-events'
import {UIHandlers} from '@api/model/ui-handlers'
import {Icon} from '@components/common/base/icon'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {usePlatformEventEffect} from '@containers/hooks'
import {Column} from '@extensions/column'

export type ExtensionInColumn = {
  title: string
}

interface ExtensionsInColumnProps {
  boardId: DataObjectId
  columnId: DataObjectId
}

export const ExtensionsInColumn = (props: ExtensionsInColumnProps) => {
  const [extensionsInColumnTitles, setExtensionsInColumnTitles] = useState<
    string[]
  >([])
  const column = Column.getById(props.columnId)

  usePlatformEventEffect(
    PlatformEvents.events.updateExtensionsInColumn,
    () => {
      const extensionsInColumn = UIHandlers.extensionsInColumn(column)

      setExtensionsInColumnTitles(
        extensionsInColumn.map(extension => extension.title)
      )
    },
    [column]
  )

  if (extensionsInColumnTitles.length === 0) {
    return null
  }

  return (
    <Tooltip
      content={`${
        Lang.msg.extensionsInColumnLabel
      } ${extensionsInColumnTitles.join(', ')}`}
      delay={0}
    >
      <Icon icon="IconPuzzle" />
    </Tooltip>
  )
}
